module.exports = __webpack_public_path__ + "img/20190713124325443.81c62ece.png";